export default __webpack_public_path__ + "static/portfolio-mas-3-4917192d467a9cdd54d0048884c7d4f8.jpg";